import React from 'react';
import { ArrowRightIcon, DatabaseIcon } from 'lucide-react';
interface IndustryLink {
  title: string;
  description: string;
  href: string;
  count?: string;
}
interface IndustryDatabaseLinksProps {
  currentIndustry?: string;
  links?: IndustryLink[];
}
const defaultLinks: IndustryLink[] = [{
  title: 'Doctor contacts database',
  description: 'Access medical practices and physicians with verified owner contacts.',
  href: 'https://openmart.com/data/doctors',
  count: '180K+'
}, {
  title: 'Dentist contacts database',
  description: 'Find dental practices with verified owner emails and phones.',
  href: 'https://openmart.com/data/dentists',
  count: '150K+'
}, {
  title: 'Lawyer contacts database',
  description: 'Connect with law firms and attorneys across the US.',
  href: 'https://openmart.com/data/lawyers',
  count: '200K+'
}, {
  title: 'Real estate agent database',
  description: 'Reach real estate agents and brokers with verified details.',
  href: 'https://openmart.com/data/real-estate-agents',
  count: '300K+'
}, {
  title: 'Restaurant owner database',
  description: 'Access restaurant owners and managers nationwide.',
  href: 'https://openmart.com/data/restaurants',
  count: '500K+'
}, {
  title: 'Property management database',
  description: 'Find property management companies with verified contacts.',
  href: 'https://openmart.com/data/property-management',
  count: '120K+'
}];
export function IndustryDatabaseLinks({
  currentIndustry,
  links = defaultLinks
}: IndustryDatabaseLinksProps) {
  return <section className="py-24 bg-slate-50" data-id="element-2569">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2570">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2571">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-2572">
            Explore other{' '}
            <span className="text-blue-600" data-id="element-2573">industry databases</span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-2574">
            Access verified owner contacts across multiple industries. Each
            database includes verified emails, phones, and 30+ enriched data
            points.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2575">
          {links.map(link => <a key={link.href} href={link.href} className="group bg-white rounded-2xl p-6 border-2 border-slate-200 hover:border-blue-500 hover:shadow-lg transition-all duration-200" data-id="element-2576">
              <div className="flex items-start justify-between mb-4" data-id="element-2577">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors" data-id="element-2578">
                  <DatabaseIcon className="w-6 h-6" data-id="element-2579" />
                </div>
                {link.count && <div className="text-right" data-id="element-2580">
                    <div className="text-lg font-bold text-blue-600" data-id="element-2581">
                      {link.count}
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-2582">contacts</div>
                  </div>}
              </div>

              <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-2583">
                {link.title}
              </h3>
              <p className="text-sm text-slate-600 mb-4 leading-relaxed" data-id="element-2584">
                {link.description}
              </p>

              <div className="flex items-center gap-1.5 text-sm font-semibold text-blue-600 group-hover:gap-2.5 transition-all" data-id="element-2585">
                Explore database
                <ArrowRightIcon className="w-4 h-4" data-id="element-2586" />
              </div>
            </a>)}
        </div>

        <div className="mt-12 text-center" data-id="element-2587">
          <p className="text-sm text-slate-500" data-id="element-2588">
            Looking for a different industry?{' '}
            <a href="https://openmart.com/data" className="text-blue-600 font-semibold hover:underline" data-id="element-2589">
              Browse all databases →
            </a>
          </p>
        </div>
      </div>
    </section>;
}